import axios, { AxiosResponse } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import {
    BriefClassificationResponse,
    BriefTierDataParams,
    DynamicMatchingCreationResponse,
    Extractor,
    LeafClassification,
    MetadataClassification,
    PollingResponse,
} from '.';

export interface AdditionalDataRequest extends DynamicMatchingCreationResponse {
    leaf_classification: LeafClassification;
    user_input: string;
    extractors: Extractor[];
    metadata?: MetadataClassification;
    tier_data?: BriefTierDataParams;
}

export const extractAdditionalDataUrl = pathfinder('classify_dm_additional_data');

export const extractAdditionalData = async ({
    leaf_classification,
    user_input,
    context_id,
    extractors,
    metadata,
    tier_data,
}: AdditionalDataRequest) =>
    axios.post<BriefClassificationResponse, AxiosResponse<PollingResponse>, AdditionalDataRequest>(
        extractAdditionalDataUrl,
        {
            context_id,
            leaf_classification,
            user_input,
            extractors,
            metadata,
            tier_data,
        }
    );
